// S&S Activewear API Service
// This service handles communication with our Firebase Functions for S&S API operations

const FIREBASE_FUNCTIONS_BASE = 'https://us-central1-apparel-logistics-447003-e318e.cloudfunctions.net';

class SSApiService {
  constructor() {
    this.baseUrl = FIREBASE_FUNCTIONS_BASE;
  }

  // Test S&S API connection
  async testConnection() {
    try {
      const response = await fetch(`${this.baseUrl}/testSSConnection`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error testing S&S API connection:', error);
      throw error;
    }
  }

  // Get tracking data by date range for building local mapping
  async getTrackingDataByDateRange(days = 10) {
    try {
      const response = await fetch(`${this.baseUrl}/getTrackingDataByDateRange`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ days }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting tracking data by date range:', error);
      throw error;
    }
  }

  // Get invoice details by invoice number and order number
  async getInvoiceDetails(invoiceNumber, orderNumber) {
    try {
      const response = await fetch(`${this.baseUrl}/getInvoiceDetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ invoiceNumber, orderNumber }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting invoice details:', error);
      throw error;
    }
  }

  // Get SanMar order details (line items) by sales order number for receiving
  async getSanMarOrderDetails(orderNumber) {
    try {
      const response = await fetch(`${this.baseUrl}/getSanMarOrderDetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ orderNumber }),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting SanMar order details:', error);
      throw error;
    }
  }
}

const ssApiService = new SSApiService();
export default ssApiService;
